import { Directive } from '@angular/core';
import { AbstractControl, ValidatorFn, NG_VALIDATORS, Validator, FormArray } from '@angular/forms';
import { LinehaulScheduleFormFields, ScheduleTrailerFormFields } from '../enums';
import * as _ from 'lodash';
import { EquipmentErrorTypes } from '../enums/equipment-error-types.enum';

export function duplicateEquipmentValidatorFunction(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control || control.disabled) {
      return null;
    }

    const errors = {};
    const dollyNbr1Ctrl = control.get(LinehaulScheduleFormFields.DollyNbr1);
    const dollyNbr2Ctrl = control.get(LinehaulScheduleFormFields.DollyNbr2);
    const dollyControls = [dollyNbr1Ctrl, dollyNbr2Ctrl];

    if (!dollyNbr1Ctrl || !dollyNbr2Ctrl) {
      return null;
    }

    const dollyVals = _.flatMap(dollyControls, dollyCtrl => dollyCtrl.value);
    if (_.some(dollyVals, val => val && _.indexOf(dollyVals, val) !== _.lastIndexOf(dollyVals, val))) {
      const primarySubject = _.uniq(
        _.filter(dollyVals, val => val && _.indexOf(dollyVals, val) !== _.lastIndexOf(dollyVals, val))
      ).join(', ');
      errors[EquipmentErrorTypes.DuplicateDolly] = {
        type: EquipmentErrorTypes.DuplicateDolly,
        displayError: true,
        primarySubject,
      };
    }

    const trailerControls = control.get(LinehaulScheduleFormFields.ScheduleTrailer);

    if (!trailerControls || !trailerControls.value) {
      return null;
    }

    const trailerVals = _.flatMap(trailerControls.value, trailerCtrl => trailerCtrl[ScheduleTrailerFormFields.TrlrNbr]);

    if (_.some(trailerVals, val => val && _.indexOf(trailerVals, val) !== _.lastIndexOf(trailerVals, val))) {
      const primarySubject = _.uniq(
        _.filter(trailerVals, val => val && _.indexOf(trailerVals, val) !== _.lastIndexOf(trailerVals, val))
      ).join(', ');
      errors[EquipmentErrorTypes.DuplicateTrailer] = {
        type: EquipmentErrorTypes.DuplicateTrailer,
        displayError: true,
        primarySubject,
      };
    }

    return _.keys(errors).length ? errors : null;
  };
}

@Directive({
  selector: '[duplicateEquipmentValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: DuplicateEquipmentValidator, multi: true }],
})
export class DuplicateEquipmentValidator implements Validator {
  constructor() {}

  validate(control: AbstractControl): { [key: string]: any } | null {
    return duplicateEquipmentValidatorFunction()(control);
  }
}
